import { render, staticRenderFns } from "./EditCompanyContactsModal.vue?vue&type=template&id=31b843d0&scoped=true&"
import script from "./EditCompanyContactsModal.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyContactsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b843d0",
  null
  
)

export default component.exports